export default __webpack_public_path__ + "static/media/5262.4c505876.png";